export const appActionMethod = {
  key: 'method',
  type: 'app',
  label: 'Method',
  description: 'The HTTP method to use for the action.',
  path: 'actions[id:{{actionId}}].api.method',
  shouldRun: ({ changes }) => {
    const paths = ['name', 'slug', 'description', 'model', 'operation', 'method', 'documentation'];
    return changes?.some((change) => paths.some((path) => change?.path?.includes(path)));
  },
  context: ['actionDocs'],
  mapContext: ({ app, action, actionDocs }) => ({
    name: action?.name,
    model: action?.model,
    operation: action?.operation || 'none',
    description: action?.description,
    slug: action?.slug,
    appName: app?.name,
    method: action?.api?.method,
    actionDocs
  }),
  formatLabel: (value) => value?.toUpperCase?.(),
  prompt: 'appActionMethod'
};
